import { useQueryClient } from "@tanstack/react-query";

import { useDeleteControlProgramsTagsTagId } from "api/generated/control-program/control-program";

import { CONTROL_PROGRAM_TAGS_QUERY_KEY } from "./useControlProgramTagsQuery";

export const useDeleteControlProgramTagMutation = () => {
    const queryClient = useQueryClient();

    return useDeleteControlProgramsTagsTagId({
        mutation: {
            onSuccess: () =>
                queryClient.invalidateQueries({
                    queryKey: [CONTROL_PROGRAM_TAGS_QUERY_KEY],
                }),
        },
    });
};
